import styled from 'styled-components';

const ContainerRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 5%;
	margin-top: -1.9%;
	height: 33%;
`;
export default ContainerRow;
